// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1063":"73c2a916295c11362d07","2326":"8c5b220bf6f482881a90","3384":"7bb4089a62b0a74bf8dd","5787":"8c5b220bf6f482881a90","7977":"8a80465300ad8c6db21c"}[chunkId] + ".css";
};